import { DogForm } from "@/domains/dog/DogFormSchema";
import { DogStepState } from "./DogStepState";
import { GlobalStepState } from "./GlobalStepState";
import { StepId } from "./StepDefinitions";

export class StepMachine {
  dogSteps: DogStepState;
  globalSteps: GlobalStepState;

  constructor(state: {
    perDogStep: Record<string, StepId>;
    globalStep: StepId;
  }) {
    this.dogSteps = new DogStepState(state.perDogStep);
    this.globalSteps = new GlobalStepState(state.globalStep);
  }

  getDogStep(dogId: string) {
    return this.dogSteps.getStep(dogId);
  }

  nextDogStep(dogId: string, form: DogForm) {
    return this.dogSteps.next(dogId, form);
  }

  prevDogStep(dogId: string) {
    return this.dogSteps.prev(dogId);
  }

  getGlobalStep() {
    return this.globalSteps.get();
  }

  nextGlobalStep() {
    return this.globalSteps.next();
  }

  prevGlobalStep() {
    return this.globalSteps.prev();
  }

  setDogStep(dogId: string, step: StepId) {
    (this.dogSteps as any).perDogStep[dogId] = step;
  }

  setGlobalStep(step: StepId) {
    (this.globalSteps as any).step = step;
  }
}
